module.exports = __webpack_public_path__ + "img/bq-sa.7467f218.svg";